/*
  予約商品の発送時期ポップアップ（snippets/reserve-notice-modal.liquid）

  対象フォーム（data-form-id）の submit を capture 段階で横取りし、モーダルを表示する。
  「確認して予約購入する」で form.requestSubmit(submitter) を呼び直し、本来の送信へ戻す。
  同一ページで snippet が複数回 render されても 1 回だけ初期化する。
*/
(function () {
  if (window.__reserveNoticeInit) return;
  window.__reserveNoticeInit = true;

  const CONFIRMED = 'data-reserve-confirmed';

  // セクション側の transform（スクロールアニメーション等）で position: fixed の基準がずれるため、
  // モーダルは body 直下へ移す。data-form-id で対象フォームと紐づくので位置は問わない
  function moveModalsToBody() {
    document.querySelectorAll('[data-reserve-notice]').forEach((modal) => {
      if (modal.parentElement !== document.body) document.body.appendChild(modal);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveModalsToBody);
  } else {
    moveModalsToBody();
  }

  function findModalForForm(form) {
    // form.id は <input name="id"> に遮られて要素を返すため、属性から文字列で取る
    const formId = form ? form.getAttribute('id') : null;
    if (!formId) return null;
    const modals = document.querySelectorAll('[data-reserve-notice]');
    for (const modal of modals) {
      if (modal.getAttribute('data-form-id') === formId) return modal;
    }
    return null;
  }

  // フォームで選択中の variant id（<input name="id">）。form.id は要素に遮られるので querySelector で取る
  function selectedVariantId(form) {
    const input = form.querySelector('input[name="id"]');
    return input ? String(input.value || '') : '';
  }

  // 商品側 is_reserve が true なら常に出す。そうでなければ、選択中の variant が
  // data-reserve-variants（バリエーション側 is_reserve が true の id 一覧）に含まれるときだけ出す（T-0372）
  function shouldIntercept(modal, variantId) {
    if (modal.getAttribute('data-reserve-product') === 'true') return true;
    const list = (modal.getAttribute('data-reserve-variants') || '').split(',').filter(Boolean);
    return list.includes(variantId);
  }

  // 発送時期の一文を、選択中の variant 用の span に切り替える。該当が無ければ商品側（id 空）の span
  function applyShipDate(modal, variantId) {
    const spans = modal.querySelectorAll('[data-reserve-ship-date]');
    if (!spans.length) return;
    let matched = false;
    spans.forEach((span) => {
      const hit = span.getAttribute('data-reserve-variant-id') === variantId;
      if (hit) matched = true;
      span.hidden = !hit;
    });
    if (!matched) {
      spans.forEach((span) => {
        span.hidden = span.getAttribute('data-reserve-variant-id') !== '';
      });
    }
  }

  function openModal(modal, form, submitter) {
    if (modal.parentElement !== document.body) document.body.appendChild(modal);
    applyShipDate(modal, selectedVariantId(form));
    modal.__form = form;
    modal.__submitter = submitter || null;
    modal.__opener = document.activeElement;
    modal.removeAttribute('hidden');
    document.documentElement.classList.add('reserve-notice-open');
    const dialog = modal.querySelector('.reserve-notice__dialog');
    // フォーカスの閉じ込めは global.js の trapFocus を流用する（aria-modal と挙動を合わせる）
    if (typeof trapFocus === 'function') {
      trapFocus(modal, dialog || modal);
    } else if (dialog) {
      dialog.focus();
    }
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.documentElement.classList.remove('reserve-notice-open');
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(modal.__opener || null);
    } else if (modal.__opener && typeof modal.__opener.focus === 'function') {
      modal.__opener.focus();
    }
    modal.__form = null;
    modal.__submitter = null;
    modal.__opener = null;
  }

  function openModals() {
    return document.querySelectorAll('[data-reserve-notice]:not([hidden])');
  }

  // submit を capture で受け、未確認なら止めてモーダルを出す
  document.addEventListener(
    'submit',
    function (evt) {
      const form = evt.target;
      if (!(form instanceof HTMLFormElement)) return;
      const modal = findModalForForm(form);
      if (!modal) return;
      if (!shouldIntercept(modal, selectedVariantId(form))) return;
      if (form.hasAttribute(CONFIRMED)) {
        form.removeAttribute(CONFIRMED); // 毎回表示する（記憶しない）
        return;
      }
      evt.preventDefault();
      evt.stopImmediatePropagation();
      openModal(modal, form, evt.submitter);
    },
    true
  );

  document.addEventListener('click', function (evt) {
    const confirmBtn = evt.target.closest('[data-reserve-confirm]');
    if (confirmBtn) {
      const modal = confirmBtn.closest('[data-reserve-notice]');
      const form = modal && modal.__form;
      const submitter = modal && modal.__submitter;
      closeModal(modal);
      if (!form) return;
      form.setAttribute(CONFIRMED, '');
      if (typeof form.requestSubmit === 'function') {
        if (submitter && submitter.form === form) {
          form.requestSubmit(submitter);
        } else {
          form.requestSubmit();
        }
      } else {
        form.submit();
      }
      return;
    }

    const closeBtn = evt.target.closest('[data-reserve-close]');
    if (closeBtn) {
      closeModal(closeBtn.closest('[data-reserve-notice]'));
    }
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape') return;
    openModals().forEach((modal) => closeModal(modal));
  });
})();
